var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-lg-4 col-sm-6" }, [
    _c("div", { staticClass: "lc-project-box box-shadow" }, [
      _c(
        "div",
        { class: ["lc-project", { "lc-voted": _vm.ranking != null }] },
        [
          _c("ProjectCardCarousel", {
            attrs: {
              images: _vm.getProjImages(),
              lifeDetailsUrl: _vm.project.life_details_url,
              "project-data": _vm.project
            }
          }),
          _c("BadgesComponent", {
            attrs: {
              badgesData: _vm.getBadgesData(),
              projectId: _vm.project.id
            }
          }),
          false
            ? _c(
                "div",
                {
                  class: [
                    "lc-data-panel",
                    _vm.voting_enabled ? "vote-panel" : ""
                  ]
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "lc-project-data",
                      on: {
                        click: function($event) {
                          return _vm.navigate(_vm.project.life_details_url)
                        }
                      }
                    },
                    [
                      _c("h5", {
                        staticClass: "lc-project-title",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.project.life_challenge_project_name
                          )
                        }
                      }),
                      _c("div", {
                        staticClass: "lc-project-country",
                        domProps: {
                          innerHTML: _vm._s(_vm.project.country_name)
                        }
                      }),
                      _c(
                        "i",
                        {
                          staticClass: "material-icons desktop",
                          on: {
                            click: function($event) {
                              return _vm.navigate(_vm.project.life_details_url)
                            }
                          }
                        },
                        [_vm._v("keyboard_arrow_right")]
                      )
                    ]
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }